export interface PostHelpRequestBulkFetch {
  helpRequests: HelpRequest[];
}

export enum HelpRequestStatus {
  NEW = "NEW",
  RESOLVED = "RESOLVED",
}

export interface HelpRequest {
  // AP2-6506: numeric for legacy, or a UUID string for a Lease Domain-sourced help request
  // (help_requests.help_request_id).
  id: number | string; // 576, or "b1f2c3d4-..."
  // AP2-6506: null for a Lease Domain-sourced help request - LD.API has no per-topic id, only a
  // joined display-name string (see helpRequestTopic below).
  helpRequestTopicId: number | null; // 2,
  helpStatus: HelpRequestStatus; // "NEW",
  additionalComments: string; // "hgfg",
  createdBy: string; // "21447",
  createdDate: string; // "2024-05-03T18:38:19.636Z",
  modifiedBy: string; // "21447",
  modifiedDate: string; // "2024-05-03T18:38:19.636Z",
  // AP2-6506: null for a Lease Domain-sourced help request - LD's help_requests table is
  // lease-level, not per-applicant, so there is no applicant to attribute it to.
  applicantId: number | null; // 21447,
  applicationId: number | string; // 14238, or a UUID for Lease Domain applications
  helpRequestTopic?: string; // "Payment"
  applicantFirstName?: string | null;
  applicantLastName?: string | null;
  applicantEmail?: string | null;
  applicantPhone?: string | null;
}
